/**
 * @requires $state ngDialog addRights mainCons app
 * @description 使用此指令显示以及修改受益人的信息
 * @example <beneficiaries-directive ></beneficiaries-directive>
 */

define('directives/mysetting/beneficiaries.directives',['app'], function (app) {
    app.directive('beneficiariesDirective', ['$state', 'projectManageService','modBussService', 'auiUpload', 'commonUtils',
        function ($state, projectManageService,modBussService, auiUpload, commonUtils) {
            return {
                restrict: 'E',
                replace: true,
                require: "?ngModel",
                templateUrl: 'directives/mysetting/beneficiaries.html',
                link: function ($scope, $element, attrs, ngModelCtrl) {
                    var Model = $scope.Model;
                    Model.maxDate = new Date('2099-12-30');
                    $scope.delcontrollerItem = delcontrollerItem;
                    $scope.addController = addController;
                    $scope.uploadCtfPicFile = uploadCtfPicFile;
                    $scope.uploadCtfPicFile1 = uploadCtfPicFile1;
                    $scope.isShowCtfWarn = isShowCtfWarn;
                    //删除某一项受益人
                    function delcontrollerItem(index) {
                        Model.controllerList.splice(index,1)
                    }
                    //添加受益人（最多可添加4人）
                    function addController() {
                        if(Model.controllerList.length >= 4 || Model.isAudting) return;
                        Model.isShowControllerList = true;
                        Model.isNewController = true;
                        var controllerInfoItem = {
                            ctfFrontUrl:'',//身份证正面
                            ctfBackUrl:'',//身份证反面
                            name:'',//实控人姓名
                            ctfCode:'',//身份证号码
                            ctfEffectiveDate:'',//身份证有效期生效日期
                            ctfExpireDate:'',//身份证有效期截止日期
                            address:''//实控人地址
                        };
                        Model.controllerList.reverse();
                        Model.controllerList.push(controllerInfoItem);
                        Model.controllerList.reverse();
                    }
                    function isShowCtfWarn (item) {
                        var reg = sysParamCfg.cftCodePattern;
                        return !(new RegExp(reg)).test(item);
                    }
                    $scope.$watch("Model.controllerList",function (newValue, oldValue) {
                        var newValueStrList = [];
                        if(newValue && newValue.length>0){
                            newValue.forEach(function (item) {
                                newValueStrList.push(JSON.stringify(item))
                            })

                        }
                        if(Model.controllerListOld && !Model.isAudting){
                            Model.isControllerChanged = false;
                            if(newValueStrList != Model.controllerListOld){
                                if(newValueStrList && Model.controllerListOld && newValueStrList.length>0 && newValueStrList.length == Model.controllerListOld.length){
                                    newValueStrList.forEach(function (controllerItem) {
                                        if(Model.controllerListOld.indexOf(controllerItem) == -1){
                                            Model.isControllerChanged = true;
                                        }
                                    })
                                }else if(newValueStrList.length == 0 && Model.controllerListOld && Model.controllerListOld.length == 0){
                                    Model.isControllerChanged = false;
                                }else{
                                    Model.isControllerChanged = true;
                                }

                            }else{
                                Model.isControllerChanged = false;
                            }
                            $scope.isGreeOrGray();
                        }

                    },true);
                    function uploadCtfPicFile(files, options, index) {
                        var ctfFrontUrlPicFileWH = "ctfFrontUrlPicFileWH"+index;
                        upload2openUP(files, options ,index ,'ctfFrontUrl', ctfFrontUrlPicFileWH);
                    }
                    function uploadCtfPicFile1(files, options, index) {
                        var ctfBackUrlPicFileWH = 'ctfBackUrlPicFileWH'+index;
                        upload2openUP(files, options, index ,'ctfBackUrl', ctfBackUrlPicFileWH);
                    }
                    //上传银行的图片
                    function upload2openUP(files, options, index, img, imgWH) {
                        auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                            if (fileUrl) {
                                //删除url 后面可以去掉
                                Model.controllerList[index][img] = fileUrl;
                                AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                                    $scope.$apply(function () {
                                        Model[imgWH] = wh;
                                    });
                                });
                            }
                        });
                    }
                    //校验身份号码格式是否正确
                    $scope.validateIDNumber = commonUtils.validateIDNumber();
                }
            }
        }])
});

